export default "__VITE_ASSET__D2m5MnyG__"